<template>
<section id="kv" class="container main">
        <div class="inner">
          <div class="box-gradient">
            <div class="gradient notIE"/>
            <div class="cover notIE">
              <img src="@/assets/img/tx1.jpg">
            </div>
          </div>
          <img src="@/assets/img/gradient_img.jpg" class="onlyIE" alt="">
          <h1>
            <Logo class="logo"/>
            <Wordmark class="wordmark"/>
          </h1>
        </div>
        <span class="spline" />
</section>
</template>

<script>
import Logo from '@/assets/icon/logo.svg?inline'
import Wordmark from '@/assets/icon/wordmark.svg?inline'

export default {
  name: 'sectionKeyVisual',
  components: {
      Logo,
      Wordmark,
  }
}
</script>

<style lang="scss">

$active-timing: 0.6s;

#kv{
  height: 100vh;
  min-height: 760px;
  justify-content: center;
  position: relative;
  padding-top: 0;
  padding-bottom: 0;
  @media #{$maxM}{
    justify-content: flex-start;
    padding-top: 130px;
    height: auto;
    min-height: unset;
  }
    .spline{
        width: 100%;
        height: 20vh;
        position: absolute;
        bottom: 0;
        left: 0;
        overflow: hidden;
          &::after{
            content: '';
            display: block;
            width: 0.5px;
            height: 100%;
            background: $black;
            margin: 0 auto;
            animation-name: none;
            transform: translateY(-100%);
            animation-duration: 2s;
            animation-iteration-count: infinite;
            animation-fill-mode: forwards;
            animation-delay: $active-timing;
            animation-timing-function: cubic-bezier(0.165, 0.84, 0.44, 1);
          }
        @media #{$maxM}{
          position: relative;
          display: block;
          height: 20vh;
          margin-top: calc(28.8vw + 5%);
        }
      }
    .inner{
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      position: relative;
      width: 48.571vw;
      max-width: 640px;
      //min-width: 70vh;
      height: 48.571vw;
      max-height: 640px;
      //min-height: 70vh;
      @media #{$maxM}{
        width: calc(100vw - 48px);
        height: calc(100vw - 48px);
        max-width: 540px;
        max-height: 540px;
      }
      h1{
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        position: absolute;
        width: 136px;
        height: 136px;
        right: calc(50% - 68px); 
        transition: $active-timing;
        transition-timing-function: cubic-bezier(0.770, 0.000, 0.175, 1.000);
        top: calc(50% - 52px);
        @media #{$maxM}{
          width: 28.8vw;
          top: 90%;
          right: unset;
          left: 50%;
          transform: translateX(-50%);
        }
        @media #{$maxXS}{
          left: 50%;
          transform: translateX(-50%);
        }
          .logo{
            margin-bottom: 16px;
          }
      }
      .onlyIE{
        height: 100%;
      }
      .box-gradient{
        width: 100%;
        height: 100%;
        opacity: 0;
        transition: 1.2s;
        transition-delay: $active-timing;
      }
      //gradient setting
        $timing: 4s; 
        .gradient{
          animation-name: gradient;
          animation-iteration-count: infinite;
          animation-timing-function: cubic-bezier(0.790, 0.465, 0.275, 0.980);
          animation-duration: $timing;
          opacity: 0.59;
          width: 144%;
          height: 144%;
          left: -22%;
          top: -22%;
          z-index: 2;
          &::after{
            opacity: 0.4;
          }
          &::before{
            animation-name: gradient;
            animation-iteration-count: infinite;
            animation-timing-function: cubic-bezier(0.790, 0.465, 0.275, 0.980);
            animation-duration: $timing*2;
            animation-direction: reverse;
          }
        }
      //noise setting
        .cover{
          opacity: 0.32;
          z-index: 0;
        }
    }

    &.active{
        .inner{
            h1{
                right: -68px;
            }
            .box-gradient{
                opacity: 1;
            }
        }
        .spline{
                &::after{
                    animation-name: spline;
                }
        }
    }
}

@keyframes gradient {
  0%{
    transform: rotate(0deg);  
  }
  50%{
    transform: rotate(180deg);  
  }
  100%{
    transform: rotate(360deg);  
  }
}

@keyframes spline {
    0%{
        transform: translateY(-100%);
    }

    100%{
        transform: translateY(100%);
    }
}

</style>
